module.exports = __webpack_public_path__ + "media/images/clients/scb_logo-dd7f2a18bbc8e7561334cbbefe213a1e.png";